<template>
    <label class="checkbox" :disabled="disabled" @click.stop>
        <input class="checkbox__input" type="checkbox" :checked="checked" :disabled="disabled" @change="toggleCheck">
        <span class="checkbox__custom"></span>
        <span v-if="title" class="checkbox__text">{{ title }}</span>
    </label>
</template>

<script>
export default {
  name: 'app-checkbox',
  props: {
    checked: Boolean,
    title: String,
    disabled: Boolean
  },
  data () {
    return {}
  },
  methods: {
    toggleCheck () {
      this.$emit('toggle-check')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.checkbox {
  display: flex;
  flex-flow: row nowrap;
  width: max-content;
  cursor: pointer;
  user-select: none;

  &__input {
    display: none;

    &:checked + .checkbox__custom {
      &:before {
        background-color: $color__orange;
        border: 1px solid $color__orange;
        box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.25);
      }

      &:after {
        display: flex;
      }
    }
  }

  &__custom {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    &:before {
      content: '';
      display: flex;
      justify-content: center;
      align-items: center;
      @include size(20px);
      border: 1px solid $color__forest-wolf;
      background: $color_main;
      border-radius: 1px;
      transition: .3s;
    }

    &:after {
      content: url('/img/svg/check_icon.svg');
      display: none;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: .3s;
    }
  }

  &__text {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-left: 15px;
    color: $color__brown;
  }

  &:hover {
    .checkbox__custom:before {
      border: 1px solid $color__orange;
    }
  }

  &[disabled] {
    pointer-events: none;

    .checkbox__custom {
      color: $color_deactive;

      &:before {
        border: 1px solid $color_deactive;
        background-color: $color_deactive-bg;
      }
    }

    .checkbox__text {
      color: $color_deactive;
    }
  }
}
</style>
